import { createLazyFileRoute } from "@tanstack/react-router";

import { ResultsPage } from "@/features/admin/routes/Results";

export const Route = createLazyFileRoute("/_auth/admin/results/")({
  component: ResultsPage,
});
